import React from 'react';

export interface OptionProps extends React.PropsWithChildren<{}> {
  value: string | number;
  onClick?: (value: string | number) => void;
}

const Option = ({ value, children }: OptionProps) => {
  return (
    <span className="widget-option-item" data-value={value}>
      {children}
    </span>
  );
}

export default Option;
